module.exports = __webpack_public_path__ + "static/media/view1.08c12bfd.jpg";